export default __webpack_public_path__ + "static/media/logo_Add.cd64388c.png";